module.exports = __webpack_public_path__ + "img/zhipinban1.1ebc79af.jpg";